<template>
  <div class="modal sign-modal">
    <div class="overlay"  @click="$emit('closeSignInModal')"></div>
    <div class="wrapper">
      <img class="close" @click="$emit('closeSignInModal')" src="./../assets/close.svg"/>
      <div class="container">
        <div class="left">
          <transition name="fade">
            <div class="left-wrapper login-content" v-if="loginContentVisible">
              <div class="title">{{ $t('Don\'t have account?') }}</div>
              <div class="link switch-register" @click="switchToRegister()">{{ $t('Please register') }}</div>
            </div>
          </transition>
          <transition name="fade">
            <div class="left-wrapper register-content" v-if="registerContentVisible || forgotPassContentVisible">
              <div class="title">{{ $t('Have account?') }}</div>
              <div class="link switch-login" @click="switchToLogin()">{{ $t('Login') }}</div>
            </div>
          </transition>
        </div>
        <div class="form">
          <div class="form-wrapper">
            <transition name="fade">
              <div class="form-fields register-content" v-if="registerContentVisible">
                <div class="form-fields-wrapper">
                  <div class="title small">{{ $t('Registration') }}</div>
                  <input type="text" :placeholder="$t('First name')" v-model="name"/>
                  <input type="text" :placeholder="$t('Last Name')" v-model="surname"/>
                  <input type="email" :placeholder="$t('Email')" v-model="email"/>
                  <input type="tel" :placeholder="$t('Phone')" v-model="phone"/>
                  <input type="password" :placeholder="$t('Password')" v-model="pass"/>
                  <input type="password" :placeholder="$t('Confirm Password')" v-model="passConfirm"/>
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms"/>
                        <div class="checkbox"></div>
                        <span class="title">{{ $t('I agree with') }} </span>
                        <a @click="$parent.goToPage('privacy')" class="title"> {{ $t('privacy policy') }}</a>
                        <span class="title"> {{ $t('and') }} </span>
                        <a @click="$parent.goToPage('terms')" class="title"> {{ $t('terms and conditions') }}</a>
                      </div>
                    </label>
                  </div>
                  <button :class="['button', {'disabled': !requiredRegisterFieldsAreFilled}]" @click="submitRegister">
                    <span>{{ $t('Enter') }}</span>
                  </button>
                  <div v-if="$parent.error" class="desc red">{{$parent.error}}</div>
                </div>
              </div>
            </transition>
            <transition name="fade">
              <div class="form-fields login-content" v-if="loginContentVisible">
                <div class="form-fields-wrapper">
                  <div class="title small">{{ $t('Login') }}</div>
                  <input type="email" :placeholder="$t('Email')" v-model="email"/>
                  <input type="password" :placeholder="$t('Password')" v-model="pass"/>
                  <div class="link" @click="switchToforgotPass">{{ $t('Forgot password?') }}</div>
                  <button class="button" @click="submitLogin">
                    <span>{{ $t('Enter') }}</span>
                  </button>
                  <div v-if="$parent.error" class="desc red">{{$parent.error}}</div>
                </div>
              </div>
            </transition>
            <transition name="fade">
              <div class="form-fields forgot-pass-content" v-if="forgotPassContentVisible">
                <div class="form-fields-wrapper">
                  <div class="title small">{{ $t('Forgot password?') }}</div>
                  <input type="email" placeholder="Email" v-model="email"/>
                  <button class="button" @click="submitForgotPass">
                    <span>{{ $t('Enter') }}</span>
                  </button>
                  <transition name="fade">
                    <div v-if="$parent.successMessage" class="desc green">{{ $t($parent.successMessage) }}</div>
                  </transition>
                  <transition name="fade">
                    <div v-if="$parent.error" class="desc red">{{$parent.error}}</div>
                  </transition>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SignInModal',
  props: [],
  components: {
  },
  data: function() {
    return {
      loginContentVisible: true,
      registerContentVisible: false,
      forgotPassContentVisible: false,
      profile: {},
      email: '',
      pass: '',
      name: '',
      surname: '',
      phone: '',
      passConfirm: '',
      terms: false
    }
  },
  mounted() {
    
  },
  computed: {
    requiredRegisterFieldsAreFilled() {
      let fieldsAreFilled;
      if(
        this.name && this.surname  && this.phone && 
        this.email && this.pass && this.passConfirm
        && this.terms 
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    }
  },
  methods: {
    closeSignInModal() {
      this.$emit('closeSignInModal')
    },
    switchToforgotPass() {
      this.loginContentVisible = false;
      this.$parent.clearError();
      setTimeout(()=> {
        this.forgotPassContentVisible = true;
      }, 500)
    },
    switchToRegister() {
      this.loginContentVisible = false;
      this.$parent.clearError();
      setTimeout(()=> {
        this.registerContentVisible = true;
      }, 500)
    },
    switchToLogin() {
      this.forgotPassContentVisible = false;
      this.registerContentVisible = false;
      this.$parent.clearError();
      setTimeout(()=> {
        this.loginContentVisible = true;
      }, 500)
    },
    submitLogin() {
      let loginData = {
        "username": this.email,
        "password": this.pass
      }
      this.$emit('login', loginData)
    },
    submitRegister() {
      let regData = {
        "name": this.name,
        "surname": this.surname,
        "email": this.email,
        "phone": this.phone,
        "password": this.pass,
        "passConfirm": this.passConfirm
      }
        this.$emit('registration', regData)
    },
    submitForgotPass() {
      let data = {
        "email": this.email
      }
      this.$emit('forgotPass', data)
    }
  }
}
</script>